import esriConfig from "@arcgis/core/config";
import * as urlUtils from "@arcgis/core/core/urlUtils";

// APISIX Gateway configuration
export const PROXY =
  process.env.REACT_APP_APISIX_PROXY || "https://api.idvilnius.lt";
export const ENDPOINT = "judumas";

// ArcGIS service URLs that will be proxied
export const PROXY_THESE_SERVERS = ["https://opencity.idvilnius.lt"];

// Track which URLs have already been configured
const handledUrls = new Set();

/**
 * Add authentication interceptor and proxy rules for ArcGIS services
 * This allows requests to be routed through APISIX with Keycloak token
 */
export const addAuthInterceptor = async (url, keycloak) => {
  if (!keycloak?.authenticated || handledUrls.has(url)) {
    return;
  }

  try {
    // Add proxy rule: requests to ArcGIS service URL are proxied through APISIX
    urlUtils.addProxyRule({
      urlPrefix: url,
      proxyUrl: `${PROXY}/${ENDPOINT}/`,
    });

    // Add request interceptor with Keycloak token
    esriConfig.request?.interceptors?.push({
      urls: url,
      before: async (params) => {
        params.requestOptions.query = params.requestOptions.query || {};
      },
      headers: {
        authorization: `Bearer ${keycloak.token}`,
      },
    });

    handledUrls.add(url);
    //console.log(`Auth interceptor added for: ${url}`);
  } catch (error) {
    console.error(`Failed to add auth interceptor for ${url}:`, error);
  }
};

/**
 * Remove authentication interceptor for a specific URL
 */
export const removeAuthInterceptor = (url) => {
  if (!esriConfig.request?.interceptors) {
    return;
  }

  esriConfig.request.interceptors = esriConfig.request.interceptors.filter(
    (interceptor) => interceptor.urls !== url
  );

  handledUrls.delete(url);
  //console.log(`Auth interceptor removed for: ${url}`);
};

/**
 * Update tokens for all active interceptors
 * Useful when Keycloak token is refreshed
 */
export const updateTokenForAllInterceptors = async (keycloak) => {
  if (!keycloak?.authenticated || !esriConfig.request?.interceptors) {
    return;
  }

  esriConfig.request.interceptors.forEach((interceptor) => {
    if (interceptor.headers) {
      interceptor.headers.authorization = `Bearer ${keycloak.token}`;
    }
  });

  //console.log("Tokens updated for all interceptors");
};

/**
 * Initialize all proxy rules and interceptors for configured servers
 */
export const initializeProxyInterceptors = async (keycloak) => {
  if (!keycloak?.authenticated) {
    console.warn("Keycloak not authenticated, skipping interceptor setup");
    return;
  }

  //console.log("Initializing proxy interceptors...");
  for (const server of PROXY_THESE_SERVERS) {
    await addAuthInterceptor(server, keycloak);
  }
};

/**
 * Log proxy configuration (for debugging)
 */
export const logProxyConfiguration = () => {
  //console.log("=== APISIX Proxy Configuration ===");
  //console.log("Proxy URL:", PROXY);
  //console.log("Endpoint:", ENDPOINT);
  //console.log("Full proxy path:", `${PROXY}/${ENDPOINT}/`);
  //console.log("Proxied servers:", PROXY_THESE_SERVERS);
  //console.log("===================================");
};
